module.exports = __webpack_public_path__ + "img/match-group-icon.cd5ca1c2.svg";